export default {
  ad_type: {
    tv: {},
    radio: {},
    print: {},
    online_video: {},
    online_display: {}
  }
}
